$(document).ready(function() {

  var pricetoremove = $("#search-product-single-product .item-price-font").html();
  if(!pricetoremove){
    return;
  }
  var cleaned = pricetoremove.replace('Price: ', '');
  $("#search-product-single-product .item-price-font").html(cleaned);

  $("#search-product-single-product").find("hr").hide();


  $("#search-product-single-product .btn-primary2").first().addClass("back-to-category");
  $("#search-product-single-product .btn-primary2").last().addClass("back-to-search");
  $(".back-to-search").html("Products Search");

  var crumbs = [];
  var counter = 0;

  $("#search-product-single-product .breadcrumbs a").each(function() {
    crumbs[counter++] = { "text": $(this).html(), "url":$(this).attr("href")};
  });

  var topbutton = $(".btn-primary2.back-to-category").clone(true);
  topbutton.removeClass("back-to-category").addClass("back-to-category-top");


  var nextone = false;
  var productname = "";

  $("#search-product-single-product #collapse0 td").each(function() {

    if (nextone) {
      productname = $(this).text();
      nextone = false;
      return;
    }
    if ($(this).text() == "Product Name") {
      nextone = true;
    }

  });

  var parentcategory = crumbs[1].text;
  var category = crumbs[crumbs.length - 1].text;

  var title = parentcategory + " - " + category + " - " + productname;
  document.title = title;
  var categorytitle = $("<div class='row'></div>");
  categorytitle.append($("<div class='category-title col-xs-12'></div>"));



  var crumbscontainer = $("<div class='row'></div>");

  var crumbbucket = $("<div class='col-md-12'></div>");

  var crumb = $("<a href='' class='crumb'></a>");

  var homecrumb = crumb.clone(true);
  homecrumb.attr("href", "/");
  homecrumb.text("Home");
  var wholecrumb = homecrumb.html() + " >> ";


  var parentcategorycrumb = crumb.clone(true);
  parentcategorycrumb.attr("href", crumbs[1].url);
  parentcategorycrumb.text(crumbs[1].text);

  wholecrumb += parentcategorycrumb.html() + " >> ";
  var categorycrumb = crumb.clone(true);
  categorycrumb.attr("href", crumbs[2].url);
  categorycrumb.text(crumbs[2].text); 
  wholecrumb += categorycrumb.html() + " >> <span>" + productname + "</span>";
  var bottombanner = $('<div id="bottom-banner" class="bottom-banner bottom-banner-form-general"><div class="text-center bottom-banner-overlay  "><h1 class="h1w mt50">Contact Us Today To Learn More</h1><br><div class="col-xs-12 col-sm-4 col-sm-offset-4" style="margin-bottom:50px;"><form id="contact-us-form" method="post" onsubmit="submitContactUs(this); return false;" action="#"><div class="form-group"><input name="Name" placeholder="Name" class="form-control" required="required" type="text"></div><div class="form-group"><input name="Company" placeholder="Company" class="form-control" required="required" type="text"></div><div class="form-group"><input name="Phone" placeholder="Phone" class="form-control" required="required" type="tel"></div><div class="form-group"><input name="Email" placeholder="Email" class="form-control" required="required" type="email"></div><div class="form-group"><textarea class="form-control" name="Message" placeholder="How can we help you?" style="resize: none;" rows="5"></textarea></div><div class="form-group"><button type="submit" class="btn btn-contact-us" style="width:250px;">SUBMIT</button></div></form></div></div>');
  //$("#contact-us").after(bottombanner);
  //$("#contact-us").remove();
  console.log('wholecrumb = '+wholecrumb);

  var headerdiv = $('<div id="page-title-header"></div>');  
  topbutton.appendTo(headerdiv);
  
  $("#search-product-single-product").before(headerdiv);
  
  $("#page-title-header").prepend(categorytitle);  
  $('.category-title').append('<h1 class="mt0">'+category+'<br class="visible-xs"/></h1>');
  $('#page-title-header .btn-primary2').appendTo('.category-title h1');
});
